module.exports = __webpack_public_path__ + "static/img/fshow-text.74c8bb04.png";